import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BlueprintPortfolio from './components/blueprint/BlueprintPortfolio';
import BlueprintNodePage from './pages/BlueprintNodePage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/"          element={<BlueprintPortfolio />} />
          <Route path="/node/:id"  element={<BlueprintNodePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
